import { render, staticRenderFns } from "./VideoContent.vue?vue&type=template&id=4c6418ff"
import script from "./VideoContent.vue?vue&type=script&lang=js"
export * from "./VideoContent.vue?vue&type=script&lang=js"
import style0 from "./VideoContent.vue?vue&type=style&index=0&id=4c6418ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports